


















import { Component, Vue } from "vue-property-decorator";

@Component
export default class HomeHeader extends Vue {
    /**
     * Images
     */
    images = {
        header: require("@/assets/img/home/header.jpg?sizes[]=1500,sizes[]=2000,sizes[]=2500,sizes[]=3000"),
        schild: require("@/assets/img/schild.png?size=300")
    };
}
